import React from "react";
import { Hero, SectionFull, Copy } from "@website2018/da-dobsonville";
import { Helmet } from "react-helmet-async";
import { decode } from 'he';
import { Link, Redirect } from "react-router-dom";
import Campaigns from "./Campaigns";
import ListWrapper from "../Nav/ListWrapper";
import ListItem from "../Nav/ListItem";

const CampaignsTemplate = props => {
  const { latest, archive, fallback, page: p } = props;

  const pastProvincialCampaigns = archive;
  const pastNationalCampaigns = fallback;
  const pastCampaignsAll = Array.from(
    new Set(pastProvincialCampaigns.concat(pastNationalCampaigns))
  );

  if (!latest.length && !archive.length) {
    return <Redirect to={"/"} />;
  }

  return [
    <Helmet
      defaultTitle={decode(p.seo.title !== "" ? p.seo.title : p.title.rendered)}
      meta={[
        {
          name: "description",
          content: p.seo.metadesc !== "" ? p.seo.metadesc : p.excerpt.rendered
        },
        {
          name: "og:title",
          content:
            p.seo["opengraph-title"] !== ""
              ? p.seo["opengraph-title"]
              : p.title.rendered
        },
        {
          name: "og:description",
          content:
            p.seo["opengraph-description"] !== ""
              ? p.seo["opengraph-description"]
              : p.excerpt.rendered
        },
        { name: "og:url", content: `` },
        { name: "og:site_name", content: `Democratic Alliance` },
        { name: "og:type", content: `business` },
        { name: "og:image", content: p.seo["opengraph-image"] || null },
        { name: "fb:app_id", content: "1262049647255981" },
        { name: "twitter:card", content: "”summary_large_image”" },
        { name: "twitter:site", content: "@our_da" },
        {
          name: "twitter:title",
          content:
            p.seo["twitter-title"] !== ""
              ? p.seo["twitter-title"]
              : p.title.rendered
        },
        {
          name: "twitter:description",
          content:
            p.seo["twitter-description"] !== ""
              ? p.seo["twitter-description”"]
              : p.excerpt.rendered
        },
        {
          name: "twitter:image",
          content: p.seo["twitter-image"] !== "" ? p.seo["twitter-image"] : null
        }
      ]}
      htmlAttributes={{ lang: "en" }}
    />,
    <Hero
      imageUrl={
        p.hero && p.hero.background_image ? p.hero.background_image.url : null
      }
      title={p.hero && p.hero.headline ? p.hero.headline : p.title.rendered}
    />,
    p.content.rendered ? (
      <SectionFull mt={"none"} mb="medium">
        <div className={"col-lg-7"}>
          <Copy intro html={p.content.rendered} />
        </div>
      </SectionFull>
    ) : null,
    latest.length ? (
      <SectionFull>
        <div className={"col-md-12"}>
          <Campaigns
            campaigns={latest}
            grid={"col-md-6"}
            title={"Latest Campaigns"}
          />
        </div>
      </SectionFull>
    ) : null,
    <SectionFull mt={latest.length ? "medium" : "none"} title="Past Campaigns">
      <div className={"col-lg-7"}>
        <ListWrapper>
          {pastCampaignsAll.map(r =>
            r.external.status ? (
              <ListItem
                key={r.slug}
                link
                title={
                  <a href={r.external.link} target={"_blank"}>
                    {r.title.rendered}
                  </a>
                }
              />
            ) : (
              <ListItem
                key={r.slug}
                link
                title={
                  <Link to={`/campaigns/${r.slug}`}>{r.title.rendered}</Link>
                }
              />
            )
          )}
        </ListWrapper>
      </div>
    </SectionFull>
  ];
};

CampaignsTemplate.defaultProps = {
  latest: [],
  archive: [],
  fallback: []
};

export default CampaignsTemplate;
